export default "__VITE_ASSET__$53_asiP__"